import { render, staticRenderFns } from "./TripsComponent.vue?vue&type=template&id=bc2e82de&"
import script from "./TripsComponent.vue?vue&type=script&lang=js&"
export * from "./TripsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports